















































































































import Vue from 'vue';

export default Vue.extend({
  name: 'InlineTextEditor',
  inheritAttrs: false,

  props: {
    value: { type: String, required: true },
    maxLength: String,
    contentRequiredMessage: String,
    textAreaMode: { type: Boolean, default: false },
    placeholder: String,
    inlineClass: String,
    inlineDisplayClass: String
  },

  data() {
    return {
      focusOnContent: false,
      showContent: false,
      required: this.contentRequiredMessage
        ? [(value) => !!value || this.contentRequiredMessage]
        : [true],
      error: false
    };
  },

  computed: {
    content: {
      get(): any {
        return this.value;
      },
      set(val): void {
        this.update(val);
      }
    },

    showPlaceholder() {
      return this.placeholder && !this.content;
    }
  },

  methods: {
    update(val) {
      this.$emit('input', val);
    },

    updateContent() {
      if (!this.error) {
        this.focusOnContent = false;

        if (this.showPlaceholder) this.content = '';

        this.$emit('update');
        this.showContent = false;
      }
    },

    onContent(e: any) {
      e.target.select();
      this.focusOnContent = true;
    },

    async contentClicked() {
      this.showContent = true;
      await this.$nextTick();
      this.$refs.content.focus();
    },

    unfocus(event) {
      this.updateContent();
      event.target.blur();
    }
  }
});
